import React, {useState, useCallback, useContext, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';

import { CREATE_SELLER_USER } from './queries';
import { ButtonContainer } from './elements';
import { NOTIFICATION_OPTIONS } from './index';

import AuthContext from 'app/src/contexts/AuthContext';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewSellerUser = ({ setShowModal, refetch }) => {
  const [submitting, setSubmitting] = useState();

  const { user } = useContext(AuthContext);
  const sellerId = user.seller.id;

  const [createSellerUser] = useMutation(CREATE_SELLER_USER, {
    onCompleted: (response) => {
      if(refetch) {
        refetch();
      }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createSellerUser({ variables: input });
  });

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      sellerId,
      firstName: '',
      lastName: '',
      role: 'Admin',
      email: '',
      assetNotifications: 'include_unassigned',
    }
  });

  return (
    <View>
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Email is required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "The email should have at most 50 characters",
                matchPattern: (v) => EMAIL.test(v) ||
                  "Email address must be a valid address",
              },
            })}
          />
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Role:"
            name="role"
            options={[
              { value: 'Admin', label: 'Admin' },
              { value: 'Normal', label: 'Normal' },
            ]}
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Receive asset notifications:"
            name="assetNotifications"
            options={NOTIFICATION_OPTIONS}
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Seller User" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewSellerUser;
